const common = {
  siteName: '按摩视频大全',
  siteDescription: '海量按摩视频教程，涵盖全身放松、穴位按摩、肩颈腰背、足底反射区等专业手法演示',
  navHome: '首页',
  navCategories: '分类教程',
  navAbout: '关于我们',
  footerAbout: '关于我们',
  footerContact: '联系我们',
  footerCopyright: '© 2026 按摩视频大全 版权所有',
  readMore: '阅读全文',
  backToList: '返回列表',
  publishedOn: '发布于',
  readTime: '阅读时长',
  relatedArticles: '相关推荐',
  categoryTitle: '分类教程',
  allCategories: '全部分类',
  breadcrumbHome: '首页',
  aboutTitle: '关于我们',
  aboutSubtitle: '专业按摩视频教程平台',
  contactTitle: '联系我们',
  contactSubtitle: '有任何问题或建议，欢迎与我们联系',
  formName: '姓名',
  formEmail: '邮箱',
  formMessage: '留言内容',
  formSubmit: '提交',
  formSuccess: '提交成功，我们会尽快回复您！',
  formError: '提交失败，请稍后重试',
  noArticles: '暂无相关教程',
  featuredArticles: '精选教程',
  faqTitle: '常见问题',
  heroTitle: '专业按摩视频教程',
  heroSubtitle: '海量按摩视频教程，涵盖全身放松、穴位按摩、肩颈腰背、足底反射区等专业手法演示。跟着按摩视频一步步学习，轻松掌握居家按摩技巧。',
  heroCta: '开始学习',
  heroCtaSecondary: '了解更多',
  categoriesTitle: '按摩教程分类',
  categoriesSubtitle: '根据需求选择适合的按摩教程分类，系统学习专业按摩手法',
  statsVideos: '视频教程',
  statsStudents: '累计学员',
  statsCategories: '教程分类',
  statsSatisfaction: '学员好评率',
  featuresTitle: '为什么选择我们',
  feature1Title: '专业手法',
  feature1Desc: '由资深按摩师和专业中医师精心录制，确保每个按摩手法都正确有效',
  feature2Title: '系统学习',
  feature2Desc: '从入门到进阶，按分类系统学习，循序渐进掌握各类按摩技巧',
  feature3Title: '居家实用',
  feature3Desc: '所有教程都适合在家操作，无需专业设备，随时随地学习按摩',
  feature4Title: '高清画质',
  feature4Desc: '多角度高清拍摄，清晰展示每个按摩手法的细节和要领',
  testimonialsTitle: '学员反馈',
  testimonial1Text: '这个网站的教程非常实用！我跟着肩颈按摩的视频学了5分钟那个教程，办公时的肩颈酸痛改善了很多。讲解很详细，容易跟着做。',
  testimonial1Name: '王女士',
  testimonial1Role: '办公室白领',
  testimonial2Text: '穴位按摩教程让我对中医有了更深的了解。足三里的教程讲得特别清楚，坚持按摩了一个月，消化功能确实改善了。推荐给注重养生的朋友们！',
  testimonial2Name: '李先生',
  testimonial2Role: '养生爱好者',
  testimonial3Text: '我妈妈腰不好，我按照腰背按摩的教程帮她按摩，她感觉舒服多了。视频拍摄角度很好，每个步骤都很清楚，新手也能学会。',
  testimonial3Name: '张女士',
  testimonial3Role: '家庭主妇',
  ctaTitle: '开始您的按摩学习之旅',
  ctaSubtitle: '加入我们，学习专业按摩手法，为自己和家人带来健康与放松',
  ctaButton: '立即学习',
  aboutBrandTitle: '品牌故事',
  aboutBrandContent: '按摩视频大全创立于2023年，致力于打造最专业的中文按摩视频教程平台。我们深知现代人面临的工作压力和生活快节奏带来的身体不适，希望通过专业、易懂的视频教程，帮助每个人掌握居家按摩技巧，为自己和家人带来健康。我们的团队由资深按摩师、中医师和专业视频制作人员组成，确保每一个教程都兼具专业性和易学性。',
  aboutMissionTitle: '我们的使命',
  aboutMissionContent: '让专业的按摩知识走进千家万户。我们相信，按摩不应该只是专业按摩院的服务，每个人都应该有能力为自己和家人提供基本的按摩保健。通过我们的视频教程，将专业的按摩手法变得简单易学，让健康触手可及。',
  aboutValuesTitle: '核心价值',
  aboutValue1Title: '专业权威',
  aboutValue1Desc: '所有教程均由持证按摩师和中医师审核',
  aboutValue2Title: '实用易懂',
  aboutValue2Desc: '用最简单的语言讲解最专业的按摩手法',
  aboutValue3Title: '持续更新',
  aboutValue3Desc: '定期更新最新按摩教程和养生知识',
  aboutValue4Title: '用户至上',
  aboutValue4Desc: '根据用户反馈不断优化教程内容和体验',
  aboutReputationTitle: '学员口碑',
};

export default common;